import { render, staticRenderFns } from "./UploadBar.vue?vue&type=template&id=248570ac&"
import script from "./UploadBar.vue?vue&type=script&lang=js&"
export * from "./UploadBar.vue?vue&type=script&lang=js&"
import style0 from "./UploadBar.vue?vue&type=style&index=0&id=248570ac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBadge,VIcon,VMenu})
